import { FaucetModel } from '../faucet-model';
import { LoginMethodModel } from '../login-method-model';
import { OnboardModel } from '../onboard-model';
import { OnboardingWizard } from '../onboarding-wizard';
import { RepliesSidebar } from '../replies-sidebar';
import { SearchModel } from '../search';
import { SellModel } from '../sell-model';
import { TermsGate } from '../terms-gate';
import { TradeSidebar } from '../trade-sidebar';
import { UserSignInModel } from '../user-signin-model';
import { UserWalletModel } from '../user-wallet-model';
import { PendingTradesReconciler } from '@/client/hooks/use-pending-trade-reconciler';
import { useModelStore } from '@/client/store/model-store';
import { Toaster } from 'sonner';

export const AppModels = () => {
  const tradeOpen = useModelStore(state => state.tradeOpen);
  const setTradeOpen = useModelStore(state => state.setTradeOpen);
  const authOpen = useModelStore(state => state.authOpen);
  const setAuthOpen = useModelStore(state => state.setAuthOpen);
  const sellOpen = useModelStore(state => state.sellOpen);
  const setSellOpen = useModelStore(state => state.setSellOpen);
  const sellParams = useModelStore(state => state.sellParams);
  const searchOpen = useModelStore(state => state.searchOpen);
  const setSearchOpen = useModelStore(state => state.setSearchOpen);
  const repliesOpen = useModelStore(state => state.repliesOpen);
  const setRepliesOpen = useModelStore(state => state.setRepliesOpen);
  const howItWorksOpen = useModelStore(state => state.howItWorksOpen);
  const setHowItWorksOpen = useModelStore(state => state.setHowItWorksOpen);
  const faucetOpen = useModelStore(state => state.faucetOpen);
  const setFaucetOpen = useModelStore(state => state.setFaucetOpen);
  const walletOpen = useModelStore(state => state.walletOpen);
  const setWalletOpen = useModelStore(state => state.setWalletOpen);
  const loginOpen = useModelStore(state => state.loginOpen);
  const setLoginOpen = useModelStore(state => state.setLoginOpen);
  const onboardingOpen = useModelStore(state => state.onboardingOpen);
  const setOnboardingOpen = useModelStore(state => state.setOnboardingOpen);

  return (
    <>
      <OnboardModel open={howItWorksOpen} setOpen={setHowItWorksOpen} />
      <FaucetModel open={faucetOpen} setOpen={setFaucetOpen} />
      <TradeSidebar open={tradeOpen} setOpen={setTradeOpen} />
      <LoginMethodModel open={loginOpen} setOpen={setLoginOpen} />
      <OnboardingWizard open={onboardingOpen} setOpen={setOnboardingOpen} />
      <UserSignInModel open={authOpen} setOpen={setAuthOpen} />
      <SellModel
        open={sellOpen}
        setOpen={setSellOpen}
        marketAddress={sellParams.marketAddress}
        optionAddress={sellParams.optionAddress}
      />
      <SearchModel open={searchOpen} setOpen={setSearchOpen} />
      <RepliesSidebar open={repliesOpen} setOpen={setRepliesOpen} />
      <UserWalletModel open={walletOpen} setOpen={setWalletOpen} />
      <TermsGate />
      <PendingTradesReconciler />
      <Toaster
        position="top-center"
        richColors={true}
        closeButton={true}
        duration={2e3}
        toastOptions={{
          classNames: { closeButton: '!border-none' },
        }}
      />
    </>
  );
};
